import { createSlice} from "@reduxjs/toolkit"
    
let session_user = JSON.parse(sessionStorage.getItem("user"))

const studentSlice = createSlice({
    
    name: "student",
    initialState: {
        studentID: "",
        studentName: "",
        studentPasscode: "",
        assignedTrainer: "",
        products: [],
        quantity: 0,
        total: 0
    },

    reducers: {
        addProduct: (state, action) => {
            let session_user = JSON.parse(sessionStorage.getItem("user"))
            state.quantity += 1
            session_user.quantity +=1

            state.products.push(action.payload)
            session_user.products.push(action.payload)

            state.total += action.payload.price * action.payload.quantity;
            session_user.totalAmount += action.payload.price * action.payload.quantity;
            
            sessionStorage.setItem("user", JSON.stringify(session_user))
        },

        removeProduct: (state, action) => {
            let session_user = JSON.parse(sessionStorage.getItem("user"))
            state.quantity -= 1
            session_user.quantity -= 1

            state.products = state.products.filter((product) => product._id !== action.payload._id)
            session_user.products = session_user.products.filter((product) => product._id !== action.payload._id)

            state.total -= action.payload.price * action.payload.quantity
            session_user.totalAmount -= action.payload.price * action.payload.quantity

            sessionStorage.setItem("user", JSON.stringify(session_user))
        },

        incrementProduct: (state, action) => {
            let session_user = JSON.parse(sessionStorage.getItem("user"))
            // eslint-disable-next-line
            state.products.map((product) => {
                if (product._id === action.payload._id) {
                    if (product.quantity < 20) {
                        product.quantity += 1
                        state.total += action.payload.price
                    }  
                }
            })

            session_user.products.map((product) => {
                if (product._id === action.payload._id) {
                    if (product.quantity <20) {
                        product.quantity += 1
                        session_user.totalAmount += action.payload.price
                        console.log("increment clickd")
                        sessionStorage.setItem("user", JSON.stringify(session_user))
                        window.location.reload()
                    }    
                }
             })
        },

        decrementProduct: (state, action) => {
            let session_user = JSON.parse(sessionStorage.getItem("user"))
            // eslint-disable-next-line
            state.products.map((product) => {
                if (product._id === action.payload._id) {
                    if (product.quantity > 1) {
                        product.quantity -= 1
                        state.total -= action.payload.price
                    }
                }
            })

            session_user.products.map((product) => {
                if (product._id === action.payload._id) {
                    if (product.quantity > 1) {
                        product.quantity -= 1
                        session_user.totalAmount -= action.payload.price
                    }
                    sessionStorage.setItem("user", JSON.stringify(session_user))
                    window.location.reload()
                }
            })

        },

        addStudent: (state, action) => {
            state.studentName = action.payload.username;
            state.studentPasscode = action.payload.password;
            state.assignedTrainer = action.payload.assignedTrainer
            state.studentID = action.payload._id
        }
    }
    
});
sessionStorage.setItem("user", JSON.stringify(session_user))

export const { addProduct, incrementProduct, decrementProduct, removeProduct, addStudent } = studentSlice.actions
export default studentSlice.reducer;